import moment from 'moment';

export const STATUS_CODE = {
  "CREATE": {
    "lookupCode": "CREATE",
    "lookupValue": "新增"
  },
  "PLANNED_PRODUCT": {
    "lookupCode": "PLANNED_PRODUCT",
    "lookupValue": "已排产"
  },
  "PUBLISHED": {
    "lookupCode": "PUBLISHED",
    "lookupValue": "已发布"
  },
  "DISPATCHED": {
    "lookupCode": "DISPATCHED",
    "lookupValue": "已派工"
  },
  "CANCELED": {
    "lookupCode": "CANCELED",
    "lookupValue": "已取消"
  },
  "START_WORK": {
    "lookupCode": "START_WORK",
    "lookupValue": "已开工"
  },
  "COMPLETED": {
    "lookupCode": "COMPLETED",
    "lookupValue": "已完成"
  },
  "RECEIVED": {
    "lookupCode": "RECEIVED",
    "lookupValue": "已入库"
  },
  "CLOSED": {
    "lookupCode": "CLOSED",
    "lookupValue": "已关闭"
  },
  "ALL": {
    "lookupCode": "ALL",
    "lookupValue": "全部"
  }
}

// 展示的工单状态
const {
  CREATE,
  PLANNED_PRODUCT,
  PUBLISHED,
  DISPATCHED,
  RECEIVED,
  ALL
} = STATUS_CODE;
export const STATUS_CODE_TAB_V = {
  CREATE,
  PLANNED_PRODUCT,
  PUBLISHED,
  DISPATCHED,
  RECEIVED,
  ALL
}

export const TICKET_TABLE_TYPE = {
  ticketInfo: {
    label: '工单信息',
    value: 1
  },
  materialInfo: {
    label: '工单用料表',
    value: 2
  },
  relateBill: {
    label: '关联工单',
    value: 3
  }
}

// 发料状态
export const DISPATCH_STATUS = {
  notFeeding: { label: '未发料', value: 'N' },
  feeding: { label: '已发料', value: 'Y' }
}

// 投料状态
export const FEED_STATUS = {
  notFeeding: { label: '未投料', value: 'N' },
  feeding: { label: '已投料', value: 'Y' }
}

export const YES_OR_NOT = {
  Y: '是',
  N: '否'
}
export function formatDate (date) {
  if(date) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss')
  }
  return '';
}

export const TICKET_INFO_COL = [
  {
    // title: "工作中心",
    dataIndex: "workCenterName",
    scopedSlots: { customRender: 'workCenterName', title: "workCenterNameTitle" },
    width: 130,
    stickyFixed: 'left'
  },
  {
    // title: "班组",
    dataIndex: "teamGroupName",
    scopedSlots: { title: "teamGroupNameTitle" },
    width: 110,
    stickyFixed: 'left'
  },
  {
    title: "MO号",
    dataIndex: "wipEntityName",
    width: 140,
    stickyFixed: 'left'
  },
  {
    title: "计划单号",
    dataIndex: "orderNo"
  },
  {
    title: "父级工单号",
    dataIndex: "upstreamWorkNumber",
    width: 140
  },
  {
    title: "MO状态",
    dataIndex: "statusName"
  },
  {
    title: "物料编码",
    dataIndex: "itemCode"
  },
  {
    title: "物料名称",
    dataIndex: "itemName",
    scopedSlots: { customRender: 'textEllipsis' }
  },
  { title: "工艺大类", dataIndex: "productBroadCategoryName" },
  {
    title: "规格描述",
    dataIndex: "specification",
    scopedSlots: { customRender: 'textEllipsis' }
  },
  {
    title: "计划数量",
    dataIndex: "planQuantity"
  },
  {
    title: "完工数量",
    dataIndex: "quantityCompleted"
  },
  {
    title: "剩余数量",
    dataIndex: "quantityRemaining"
  },
  {
    title: "已入库数量",
    dataIndex: "receivedQuantity"
  },
  {
    title: "已送货数量",
    dataIndex: "deliveredQuantity"
  },
  {
    // title: "计划开始时间",
    dataIndex: "scheduledStartDate",
    scopedSlots: { customRender: 'scheduledStartDate', title: "scheduledStartDateTitle" },
    width: 180
  },
  {
    // title: "计划完成时间",
    dataIndex: "scheduledCompletionDate",
    scopedSlots: { customRender: 'scheduledCompletionDate', title: "scheduledCompletionDateTitle" },
    width: 180
  },
  {
    title: "派工时间",
    dataIndex: "dispatchingDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "开工时间",
    dataIndex: "startDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "完工时间",
    dataIndex: "completionDate",
    scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "入库时间",
    dataIndex: "receivedDate",
   scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "一次考核交期",
    dataIndex: "deliveryDate",
   scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "变更后考核交期",
    dataIndex: "assessmentDeliveryDate",
   scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "第一次报工时间",
    dataIndex: "firstReportingTime",
   scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  {
    title: "是否合格",
    dataIndex: "qualifiedFlag",
    scopedSlots: { customRender: 'YES_OR_NOT' }
  },
  {
    title: "是否锁库",
    dataIndex: "lockStockFlag",
    scopedSlots: { customRender: 'YES_OR_NOT' }
  },
  {
    title: "完工子库",
    dataIndex: "completedSublibrary"
  },
  {
    title: "MO类型",
    dataIndex: "jobTypeName"
  },
  {
    title: "业务类型",
    dataIndex: "businessTypeName"
  },
  {
    title: "大货类型",
    dataIndex: "orderTypeName"
  },
  {
    title: "车间",
    dataIndex: "workShopDesc",
    width: 130
  },
  {
    title: "BOM版本号",
    dataIndex: "bomVersion"
  },
  {
    title: "备注",
    dataIndex: "remarks",
    scopedSlots: { customRender: 'remarks' },
    width: 170
  },
  {
    title: "创建时间",
    dataIndex: "createTime",
   scopedSlots: { customRender: 'formatDate' },
    width: 120
  },
  { title: "需求组织", dataIndex: "organizationName", width: 170 },
  { title: "加工商组织", dataIndex: "desOrganizationName", width: 170 },
  {
    title: "操作",
    dataIndex: "operation",
    scopedSlots: { customRender: "operation" },
    width: 100,
    stickyFixed: 'right'
  }
]

// 表格字段-工单用料表
export const TICKET_MATERIAL_COL = [
  { title: '加工组织', dataIndex: 'desOrganizationName', width: 180, stickyFixed: 'left', align: 'center' },
  { title: '工单号', dataIndex: 'wipEntityName', width: 160, stickyFixed: 'left', align: 'center' },
  { title: '父工单号', dataIndex: 'upstreamWorkNumber', width: 160, stickyFixed: 'left', align: 'center' },
  { title: '工单状态', dataIndex: 'ccStatusName', width: 100, stickyFixed: 'left', align: 'center' },
  { title: '成品-物料编码', dataIndex: 'assemblyItemCode', stickyFixed: 'left', width: 160, align: 'center' },
  { title: '成品-物料名称', width: 160, dataIndex: 'assemblyItemName', align: 'center', ellipsis: true },
  { title: '成品-规格描述', dataIndex: 'assemblySpecification', width: 120, align: 'center', ellipsis: true },
  {
    // title: '组件物料',
    dataIndex: 'itemCode',
    width: 120,
    scopedSlots: { title: "roItemCodeTitle" },
    align: 'center'
  },
  { title: '组件-物料名称', width: 120, dataIndex: 'itemName', align: 'center', ellipsis: true },
  { title: '组件-规格描述', dataIndex: 'specification', width: 180, align: 'center', ellipsis: true },
  { title: '单位', dataIndex: 'primaryUom', width: 120, align: 'center' },
  {
    // title: '用量',
    dataIndex: 'quantityPerAssembly',
    width: 120,
    scopedSlots: { title: "quantityPerAssemblyTitle" },
    align: 'center'
  },
  { title: '产出率', dataIndex: 'componentYield', width: 120, align: 'center' },
  { title: '必须', dataIndex: 'requiredQuantity', width: 120, align: 'center' },
  { title: '已发料', dataIndex: 'quantityIssued', width: 120, align: 'center' },
  { title: '未发料', dataIndex: 'quantityOpen', width: 120, align: 'center' },
  { title: '供应类型', dataIndex: 'wipSupplyTypeName', width: 120, align: 'center' },
  { title: 'MRP净值', width: 120, dataIndex: 'mrpFlag', align: 'center', scopedSlots: { customRender: 'YES_OR_NOT' } },
  { title: '供应子库', width: 120, dataIndex: 'supplySublibrary', align: 'center' },
  { title: '供应货位', width: 120, dataIndex: 'supplyLocation', align: 'center' },
  { title: '需求日期', dataIndex: 'dateRequired', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
  { title: '创建人', width: 120, dataIndex: 'createName', align: 'center' },
  { title: '创建时间', dataIndex: 'createTime', scopedSlots: { customRender: 'formatDate' }, width: 150, align: 'center' },
  { title: '最后更新人', width: 120, dataIndex: 'updateName', align: 'center' },
  { title: '最后更新时间', dataIndex: 'updateTime', scopedSlots: { customRender: 'formatDate' }, align: 'center' }
]

export function positiveNumValidate(rule, value, callbackFunc) {
  if(value === undefined || value === '' || value === null) {
    callbackFunc('不能为空');
  } else if(value < 0) {
    callbackFunc('不可小于等于0')
  }else {
    callbackFunc()
  }
}
